import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function WeekChampionIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4350" data-mp="321q1zj2ix0c6">
      
      <div className="relative w-full h-full bg-gradient-to-b from-indigo-900 to-purple-900 overflow-hidden" data-id="element-4351" data-mp="2x2djfaioqffe">
        {/* Background: Spotlight and Stars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4352" data-mp="2nbiutzhyv3qs">
          
          {/* Spotlight */}
          <path d="M100 0 L180 200 L20 200 Z" fill="url(#spotlight-grad)" opacity="0.4" data-id="element-4353" data-mp="2eakmj50hwa2e" />
          
          {/* Stars */}
          <circle cx="40" cy="50" r="2" fill="#FDE047" data-id="element-4354" data-mp="29c9e8ypum7ma" />
          <circle cx="160" cy="70" r="3" fill="#FDE047" data-id="element-4355" data-mp="20pmgk2xihbz8" />
          <circle cx="150" cy="30" r="1.5" fill="#FDE047" data-id="element-4356" data-mp="20o2zwb7y0ywx" />
          <circle cx="60" cy="120" r="2" fill="#FDE047" data-id="element-4357" data-mp="25gclxg5xtetx" />
          <circle cx="140" cy="140" r="1.5" fill="#FDE047" data-id="element-4358" data-mp="25hxgh5s94xrs" />

          <defs data-id="element-4359" data-mp="1rpzctahb7u30">
            <linearGradient id="spotlight-grad" x1="100" y1="0" x2="100" y2="200" gradientUnits="userSpaceOnUse" data-id="element-4360" data-mp="1rqixv029ayl9">
              
              <stop offset="0%" stopColor="#FDE047" stopOpacity="0.8" data-id="element-4361" data-mp="2kddetmzv7ftz" />
              <stop offset="100%" stopColor="#FDE047" stopOpacity="0" data-id="element-4362" data-mp="2ke4x5w4gbh2b" />
            </linearGradient>
          </defs>
        </svg>

        {/* Background: Podium */}
        <svg className="absolute bottom-0 left-0 w-full h-1/3 z-0" viewBox="0 0 200 66" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-4363" data-mp="2ae4d27yrcwx2">
          
          <path d="M40 30 L160 30 L180 66 L20 66 Z" fill="#475569" data-id="element-4364" data-mp="z0aej4vzi853" />
          <path d="M40 30 L160 30 L160 35 L40 35 Z" fill="#94A3B8" data-id="element-4365" data-mp="z23gw7zke67a" />
          <path d="M60 45 L140 45 L145 66 L55 66 Z" fill="#334155" data-id="element-4366" data-mp="13zwrrebtbodw" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[15%]" data-id="element-4367" data-mp="jwhbfpnq1hy6">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-4368" data-mp="fwozr4316vol">
            <DjaySpecimen look={{
            variant,
            accessory: 'trophy'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4369" data-mp="b3vumf3nhlbz" />
            
          </div>
        </div>

        {/* Foreground: Confetti */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4370" data-mp="3sbr7ag10pqxi">
          
            <rect x="30" y="80" width="6" height="12" fill="#EF4444" transform="rotate(45 30 80)" data-id="element-4371" data-mp="3jcdxfm8zf0c9" />
          
            <rect x="170" y="100" width="8" height="8" fill="#3B82F6" transform="rotate(15 170 100)" data-id="element-4372" data-mp="1mkdt0kqt5y19" />
          
            <rect x="50" y="140" width="10" height="6" fill="#10B981" transform="rotate(-20 50 140)" data-id="element-4373" data-mp="1hkhnui6dk0k4" />
          
            <rect x="150" y="160" width="6" height="10" fill="#F59E0B" transform="rotate(60 150 160)" data-id="element-4374" data-mp="1p3h4wh6d5g0b" />
          
          </svg>}
      </div>
    </DjayIllustrationBase>;
}